module.exports = __webpack_public_path__ + "img/top4.3f1973f7.png";